import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { formPaths } from '@shared/constants/form-paths.const';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { SCHEDA_ALLEGA_PATHS } from '../common/consts/scheda-allega-paths.const';
import { getCoopAltreCoopControl } from '../validators/helpers/coop-altre-coop-form.helpers';
import { debounceTime, merge, startWith } from 'rxjs';
import { Utilities } from '@core/helpers/utilities';
import { defineObbligatorietaSchedeSettore } from '../../../../../features/schede-settore/shared/models/helpers/schede-settore.helpers';

/** defineObbligatorietaSchedeSettore (chiamata sotto) ricalcola l'obbligatorietà di TUTTE le
 * 10 schede di settore, non solo Altre Coop — vedi commento sulla funzione in schede-settore.helpers.ts. */
export const setCoopAltreCoopSpecificListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    const datiIndetificativiGroup = getGroup(form, formPaths.datiIdentificativi);
    const my_ckSezAlboCorretta = getControl(datiIndetificativiGroup, 'my_ckSezAlboCorretta');
    const my_SezEnte = getControl(datiIndetificativiGroup, 'my_SezEnte');
    const schedeValueChanges = SCHEDA_ALLEGA_PATHS.map((path) => {
        const schedaControl = getCoopAltreCoopControl(form, path);
        return schedaControl.valueChanges.pipe(startWith(schedaControl.value));
    });
    merge(...schedeValueChanges, my_ckSezAlboCorretta.valueChanges.pipe(startWith(my_ckSezAlboCorretta?.value)), my_SezEnte.valueChanges.pipe(startWith(my_SezEnte?.value)))
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            defineObbligatorietaSchedeSettore(form, store);
        });
};
